query GetUsers($first: Int, $after: String, $search: String, $includeUnprovisioned: Boolean) {
    users(
        first: $first
        after: $after
        search: $search
        includeUnprovisioned: $includeUnprovisioned
    ) {
        pageInfo {
            __typename
            endCursor
            hasNextPage
        }
        edges {
            node {
                id
                name
                avatarUrl
                initials
                isEnabled
                calendarSync {
                    isEnabled
                }
                isAgent
            }
        }
    }
}
